// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5d37c7e4","343":"125ceaea","453":"62d111a0","732":"dc9d4d53","977":"7a5dbdb5"}[chunkId] + ".chunk.js";
};